import { render, staticRenderFns } from "./AppImage.vue?vue&type=template&id=596a1eea&scoped=true&"
import script from "./AppImage.vue?vue&type=script&lang=js&"
export * from "./AppImage.vue?vue&type=script&lang=js&"
import style0 from "./AppImage.vue?vue&type=style&index=0&id=596a1eea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "596a1eea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/frontend/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('596a1eea')) {
      api.createRecord('596a1eea', component.options)
    } else {
      api.reload('596a1eea', component.options)
    }
    module.hot.accept("./AppImage.vue?vue&type=template&id=596a1eea&scoped=true&", function () {
      api.rerender('596a1eea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/AppImage.vue"
export default component.exports